import React from 'react'
import { observer } from 'mobx-react'
import styles from './DepartingMessageBubble.sass'

interface DepartingMessageBubbleProps {
  displayName: string
}

export default observer(function DepartingMessageBubble({
  displayName,
}: DepartingMessageBubbleProps) {
  return (
    <div className={styles.bubbleContainer}>
      <div className={styles.bubble}>
        <span className={styles.content}>
          {displayName} has left the conversation
        </span>
      </div>
    </div>
  )
})
